module.exports = __webpack_public_path__ + "img/doubleSideTriangleHorizontal.9694d807.svg";